import styled from '@emotion/styled';
import { bodyM, captionM, subTitle3, title2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { device } from '@/styles/themes';

export const InfoModalBackground = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  z-index: 99;
  background: rgba(20, 22, 23, 0.6);
  overflow-y: auto;
  @media ${device.desktop} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const InfoModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 99;
  padding: 28px 20px calc(28px + env(safe-area-inset-bottom));
  gap: 24px;
  overflow-y: scroll;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #ffffff;

  @media screen and ${device.desktop} {
    border-radius: 16px;
    padding: 32px;
    overflow: unset;
    position: relative;
    animation: inherit;
    left: initial;
    transform: initial;
    margin: auto;
    width: 460px;
  }
`;

export const MultiFromWrapper = styled.div`
  margin-top: 16px;
  height: 100%;
  @media screen and ${device.desktop} {
    margin-top: 8px;
  }
`;

export const InfoCloseImg = styled.div`
  border: none;
  background-color: transparent;
  cursor: pointer;
  @media screen and ${device.desktop} {
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  * {
    margin: 0;
  }
`;
export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  ${title2};
  color: ${vars.neutral[100]};
  @media screen and ${device.desktop} {
    ${title2};
    color: ${vars.neutral[100]};
  }
`;

export const Description = styled.p`
  ${bodyM};
  color: ${vars.neutral[60]};
  @media screen and ${device.desktop} {
    ${bodyM};
    color: ${vars.neutral[60]};
  }
`;

export const QuestionWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media screen and ${device.desktop} {
    margin-top: 8px;
  }
`;
export const Label = styled.label`
  width: 100%;
  p {
    ${captionM};
    color: ${vars.neutral[80]};
  }
  span {
    color: ${vars.neutral[60]};
  }
`;

export const Input = styled.input`
  ::placeholder {
    color: ${vars.neutral[50]};
  }
  :focus {
    border-bottom: 1px solid ${vars.neutral[80]};
  }
  width: 100%;
  padding: 8px 0 12px 0;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid ${vars.neutral[20]};
  border-radius: 0;

  ${bodyM};
  color: ${vars.neutral[100]};
`;
export const Textarea = styled.textarea`
  :focus {
    outline: none;
    border: 1px solid ${vars.neutral[80]};
  }
  padding: 14px 16px;

  min-height: 158px;

  ${bodyM};
  color: ${vars.neutral[80]};
`;

export const StepQuestion = styled.p`
  margin: 0;
  ${subTitle3};
  color: ${vars.neutral[100]};
  white-space: pre-wrap;
  word-break: keep-all;
  span {
    color: ${vars.neutral[50]};
  }
`;
